import { render, staticRenderFns } from "./newagent.vue?vue&type=template&id=05355afa&"
import script from "./newagent.vue?vue&type=script&lang=js&"
export * from "./newagent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports